import { Box, Flex, FormNumberInput, Text } from '@shared/components';

import FormImagesInput from '../form-images-input/form-images-input';

interface DoorInfoRowProps {
  label: string;
  isReadonly?: boolean;
  required?: boolean;
  uploadFiles?: (files: File[]) => Promise<string[]>;
  getFilesDownloadSignedUrls?: (fileNames: string[]) => Promise<string[]>;
}

export default function DoorInfoRow(props: DoorInfoRowProps) {
  const { label, isReadonly, required, uploadFiles, getFilesDownloadSignedUrls } = props;
  const numberField = 'entryExitDoors.numberOfDoors' as const;
  const imagesField = 'entryExitDoors.images' as const;

  return (
    <Flex
      sx={(theme) => ({
        gap: theme.spacing(6),
        justifyContent: 'space-between',
        [theme.breakpoints.down('desktop')]: {
          flexDirection: 'column',
        },
      })}
    >
      <Box sx={{ width: '320px' }}>
        <Text variant='body1' sx={{ fontWeight: 500 }}>
          {label}
          {required ? (
            <Text component='span' color='error.main'>
              {' '}
              *
            </Text>
          ) : null}
        </Text>
      </Box>
      <Flex
        sx={(theme) => ({
          flex: 1,
          flexDirection: 'column',
          gap: theme.spacing(2),
        })}
      >
        <FormNumberInput
          name={numberField}
          placeholder='ระบุจำนวนประตูห้องสอบ'
          disabled={isReadonly}
          required={!!required}
        />
        <FormImagesInput
          name={imagesField}
          label='แนบรูปภาพบริเวณประตูห้องสอบ'
          disabled={isReadonly}
          required={!!required}
          uploadFiles={uploadFiles}
          getDownloadSignedUrls={getFilesDownloadSignedUrls}
        />
      </Flex>
    </Flex>
  );
}
